<div class="container-fluid catalogue contentHeight">
    <div class="cartButton  backgroundWhiteRound">
        <div class="filter ">
            <mat-radio-group>
                <mat-radio-button class="FilterAll" value="All" [checked]="true" (change)="radioChange('All')">{{'shoppingcart.all'|translate}}</mat-radio-button>
                <mat-radio-button class="FilterLicence" value="Licence" (change)="radioChange('Licence')">{{'shoppingcart.licences'|translate}}</mat-radio-button>
                <mat-radio-button class="FilterSupport" value="Support" (change)="radioChange('Support')">{{'shoppingcart.supports'|translate}}</mat-radio-button>
                <mat-radio-button class="FilterCables" value="Cables" (change)="radioChange('Cables')">{{'shoppingcart.cables'|translate}}</mat-radio-button>
                <mat-radio-button class="FilterReseau" value="Reseau" (change)="radioChange('Reseau')">{{'shoppingcart.network'|translate}}</mat-radio-button>
                <mat-radio-button class="FilterDivers" value="Divers" (change)="radioChange('Divers')">{{'shoppingcart.various'|translate}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <button routerLink="/panier" class="btn btn-primary cartBtn" [translate]="'shoppingcart.panier'" [disabled]="!canAddToCart"> <i aria-hidden="true" class="far fa-shopping-cart color-white"></i> </button>
    </div>
    <div *ngFor="let product of productsFiltered" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 product">
        <div class="product-details m-1 backgroundWhiteRound">
            <div class="row product-header" [className]="product.typeName +' row product-header'">
                <div class="product-title">
                    <div [ngSwitch]="langue" class="productName">
                        <span *ngSwitchCase="'fr'">
                            {{product.labelP}}
                        </span>
                        <span *ngSwitchCase="'en'">
                            {{product.labelENP}}
                        </span>
                        <span *ngSwitchCase="'de'">
                            {{product.labelDEP}}
                        </span>
                        <span *ngSwitchCase="'es'">
                            {{product.labelESP}}
                        </span>
                        <span *ngSwitchCase="'it'">
                            {{product.labelITP}}
                        </span>
                        <span *ngSwitchCase="'nl'">
                            {{product.labelNLP}}
                        </span>
                        <span *ngSwitchCase="'ro'">
                            {{product.labelROP}}
                        </span>
                        <span *ngSwitchCase="'pt'">
                            {{product.labelPTP}}
                        </span>
                        <span *ngSwitchCase="'pl'">
                            {{product.labelPLP}}
                        </span>
                        <span *ngSwitchCase="'tr'">
                            {{product.labelTRP}}
                        </span>
                        <span *ngSwitchDefault>
                            {{product.labelP}}
                        </span>
                    </div>
                </div>

                <div class="qty">
                    <div class="qtyLabel">
                        <span [translate]="'shoppingcart.quantite'"></span>
                        <span *ngIf="product.typeP == 1 && product.labelP == 'Licence IxellColor Connect'" [translate]="'shoppingcart.annees'"></span>
                        <span *ngIf="product.typeP == 1 && product.labelP == 'Abonnement Backup & Statistiques'" [translate]="'shoppingcart.mois'"></span> :
                    </div>

                    <!-- chevron produits autre que licence ou abonnement -->
                    <div *ngIf="product.typeP != 1" class="product-quantity">
                        <div class="product-quantity-subtract">
                            <button *ngIf="product.available" class="chevron" (click)="removeProduct(product.labelP)"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                            <button *ngIf="!product.available" class="chevron"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                        </div>
                        <div> {{product.qte}} </div>
                        <div class="product-quantity-add">
                            <button *ngIf="product.available" class="chevron" (click)="addProduct(product.labelP)">  <i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                            <button *ngIf="!product.available" class="chevron"><i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                        </div>
                    </div>

                    <!-- chevron produits abonnement -->
                    <div *ngIf="scaleSelectBackupAndStats && product.typeP == 1 && product.labelP == 'Abonnement Backup & Statistiques'" class="product-quantity">
                        <div class="product-quantity-subtract">
                            <!--<button *ngIf="product.available" class="chevron" (click)="removeProduct(product.labelP)"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>-->
                            <!--<button *ngIf="!product.available" class="chevron"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>-->
                        </div>
                        <div> {{product.qte}} </div>
                        <div class="product-quantity-add">
                            <!--<button *ngIf="product.available" class="chevron" (click)="addProduct(product.labelP)">  <i aria-hidden="true" class="fa fa-chevron-right"></i></button>-->
                            <!--<button *ngIf="!product.available" class="chevron"><i aria-hidden="true" class="fa fa-chevron-right"></i></button>-->
                        </div>

                        <div class="product-quantity-delete">
                            <span *ngIf="product.available" class="trashProdcut" (click)="removeProduct(product.labelP)"> <i aria-hidden="true" class="fal fa-trash-alt"></i></span>
                        </div>

                    </div>

                    <!-- chevron produits licence -->
                    <div *ngIf="scaleSelect && product.typeP == 1  && product.labelP == 'Licence IxellColor Connect'" class="product-quantity">
                        <div class="product-quantity-subtract">
                            <button *ngIf="product.available" class="chevron" (click)="removeProduct(product.labelP)"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                            <button *ngIf="!product.available" class="chevron"> <i aria-hidden="true" class="fa fa-chevron-left"></i></button>
                        </div>
                        <div> {{product.qte}} </div>
                        <div class="product-quantity-add">
                            <button *ngIf="product.available" class="chevron" (click)="addProduct(product.labelP)">  <i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                            <button *ngIf="!product.available" class="chevron"><i aria-hidden="true" class="fa fa-chevron-right"></i></button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row product-Info">

                <div *ngIf="product.typeP == 1" class="product-image product-image-licence">
                    <img src="data:image/png;base64,{{product.pictureBlob2}}" alt="" />
                </div>

                <div *ngIf="product.typeP != 1" class="product-image">
                    <img src="data:image/png;base64,{{product.pictureBlob2}}" alt="" />
                </div>

                <div class="product-price-desc">

                    <div *ngIf="product.typeP != 1" class="product-description">

                    </div>

                    <div *ngIf="product.typeP == 1 && product.labelP != 'Abonnement Backup & Statistiques'" class="product-description">
                        <div class="idBalance">
                            <label [translate]="'activlist.balance'"></label>
                            <span class="mat-mdc-select-min-line"></span>
                            <mat-select [formControl]="selectScale" class="mat-select-balanceId">
                                <mat-option *ngFor="let scale of scales" [value]="scale.activationID" (click)="licenceScale(scale)" class="mat-select-balanceId-option">
                                    <!-- [disabled]="actualScaleBackupAndStats != null && scale.activationID == actualScaleBackupAndStats.activationID" -->
                                    {{scale.code}}{{'stats.common.colon'|translate}}{{scale.activationID}} {{scale.socialReason}}, {{scale.city}}
                                </mat-option>
                            </mat-select>

                            <div *ngIf="scaleSelect" class="detailScale">
                                {{scaleDetail.code}}{{'stats.common.colon'|translate}}{{scaleDetail.activationID}} {{scaleDetail.socialReason}}, {{scaleDetail.city}}
                            </div>

                            <div *ngIf="licenceDuration" class="licenceDuration">
                                <span class="font-weight-bold" [translate]="'activlist.activdateend'"></span>{{'stats.common.colon'|translate}}{{licenceDuration | date:'dd/MM/yyyy'}}
                            </div>
                        </div>
                    </div>

                    <div *ngIf="product.typeP == 1 && product.labelP == 'Abonnement Backup & Statistiques'" class="product-description">
                        <div class="idBalance">
                            <label [translate]="'activlist.balance'"></label>
                            <mat-select [formControl]="selectScaleBackupAndStats" class="mat-select-balanceId">
                                <mat-option *ngFor="let scale of scalesBackupAndStats" [value]="scale.activationID" (click)="licenceScaleBackupAndStats(scale)" class="mat-select-balanceId-option" [disabled]="actualScale != null && scale.activationID == actualScale.activationID">
                                    {{scale.code}}{{'stats.common.colon'|translate}}{{scale.activationID}} {{scale.socialReason}}, {{scale.city}}
                                </mat-option>
                            </mat-select>

                            <div *ngIf="scaleSelectBackupAndStats" class="detailScale">
                                {{scaleDetailBackupAndStats.code}}{{'stats.common.colon'|translate}}{{scaleDetailBackupAndStats.activationID}} {{scaleDetailBackupAndStats.socialReason}}, {{scaleDetailBackupAndStats.city}}
                            </div>
                        </div>
                    </div>
                    <div class="product-actions">
                        <div class="pictureZoom">
                            <button *ngIf="product.pictureZoomDisplayBlob && product.typeP != 1" (click)="openZoomModal(product)" [translate]="'shoppingcart.details'" class="details"></button>
                            <button *ngIf="product.typeP == 1 && product.labelP != 'Abonnement Backup & Statistiques'" (click)="openDetailModal(product)" [translate]="'shoppingcart.details'" class="details"></button>
                            <button *ngIf="product.typeP == 1 && product.labelP == 'Abonnement Backup & Statistiques'" (click)="openDetailModal(product)" [translate]="'shoppingcart.details'" class="details"></button>
                        </div>

                        <div class="product-price">
                            {{product.amountP | number : '1.2-2'}} € <label>{{'shoppingcart.HT'|translate}}</label><span *ngIf="product.typeP == 1 && product.labelP == 'Abonnement Backup & Statistiques'">{{'shoppingcart.parMois'|translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 100%;"></div>
</div>

<div id="ModalZoom" *ngIf="showModal">
    <div class="content backgroundWhiteRound">
        <div class="title">
            <div [ngSwitch]="langue" class="productName">
                <h1 *ngSwitchCase="'fr'">
                    {{currentProduct.labelP}}
                </h1>
                <h1 *ngSwitchCase="'en'">
                    {{currentProduct.labelENP}}
                </h1>
                <h1 *ngSwitchCase="'de'">
                    {{currentProduct.labelDEP}}
                </h1>
                <h1 *ngSwitchCase="'es'">
                    {{currentProduct.labelESP}}
                </h1>
                <h1 *ngSwitchCase="'it'">
                    {{currentProduct.labelITP}}
                </h1>
                <h1 *ngSwitchCase="'nl'">
                    {{currentProduct.labelNLP}}
                </h1>
                <h1 *ngSwitchCase="'ro'">
                    {{currentProduct.labelROP}}
                </h1>
                <h1 *ngSwitchCase="'pt'">
                    {{currentProduct.labelPTP}}
                </h1>
                <h1 *ngSwitchCase="'pl'">
                    {{currentProduct.labelPLP}}
                </h1>
                <h1 *ngSwitchCase="'tr'">
                    {{currentProduct.labelTRP}}
                </h1>
                <h1 *ngSwitchDefault>
                    {{currentProduct.labelP}}
                </h1>
            </div>
            <span class="text-right pointer close" (click)="closeModal();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
        </div>
        <div *ngIf="scaleSelect && isLicenceProduct" class="center-text-scale">
            {{scaleDetail.code}} : {{scaleDetail.activationID}} {{scaleDetail.socialReason}}, {{scaleDetail.city}}
            <br />
            <span [translate]="'activlist.activdateend'">  </span>  : {{licenceDuration | date:'dd/MM/yyyy'}}
        </div>
        <div class="center">
            <!-- *ngIf="!isLicenceProduct" -->
            <button class="arrow" (click)="switchPicture()">
                <i aria-hidden="true" class="far fa-arrow-circle-left fa-3x black"></i>
            </button>
            <img class="productImg" src="data:image/png;base64,{{currentProduct.pictureBlob2}}" *ngIf="!showZoom" alt="" />
            <img class="productImgZoom" src="data:image/png;base64,{{currentProduct.pictureZoomDisplayBlob}}" *ngIf="showZoom" alt="" />
            <button class="arrow" (click)="switchPicture()">
                <i aria-hidden="true" class="far fa-arrow-circle-right fa-3x black"></i>
            </button>
        </div>
    </div>
</div>



<div id="ModalNoRenew" class="modal" *ngIf="showModalNoRenew">
    <div class="modal-content">
        <div class="col-12 text-center">
            <span class="text-right pointer close" (click)="closeModal();">
                <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
            </span>
            <h2>{{'shoppingcart.cantRenew'|translate}}</h2>
            <span>{{'shoppingcart.mustWaitToRenew'|translate}}</span>
        </div>
    </div>
</div>

